import { Injectable } from '@angular/core';
import { HttpParams } from "@angular/common/http";
import { HttpService} from "../../../services/http.service";

const baseURL: string = 'presentations/';

export enum presentation_output_types { pdf, mail }

@Injectable({
  providedIn: 'root'
})
export class OutputTypesService {

  constructor(
      private HttpService: HttpService,
  ) {}

  get(language: string, params: HttpParams) {
    return this.HttpService.get(baseURL+'read/output-types/'+language, params );
  }
  getOne(id :number, language: string) {
    let params=new HttpParams().append('id',id.toString());
    return this.HttpService.get(baseURL+'read/output-types/'+language, params );
  }
}
